// -----------------------------------------------------------------------------------------
// Module Dependencies
//
// -----------------------------------------------------------------------------------------
require("webpack-jquery-ui/css");
import $ from 'jquery';

// -----------------------------------------------------------------------------------------
// JHSPH Styles
// This are global jhsph styles that apply all SPH site, these style shouldn't be updated.
// -----------------------------------------------------------------------------------------
import "../scss/jhsph.scss";

// -----------------------------------------------------------------------------------------
// Multidivisional Styles
// These files can be altered/updated.
// -----------------------------------------------------------------------------------------
import "../scss/multidivisional.scss";


// -----------------------------------------------------------------------------------------
// JavaScript Modules
// -----------------------------------------------------------------------------------------
import {ModSlideshow} from "./modules/slideshow";
import {ModColorSlideshow} from "./modules/color-slideshow";
// import {SimpleSlideShow} from "./modules/simple-image-slideshow";
import {ModFwSlideShow} from "./modules/fw-slideshow";
import {CLFModAccordion} from "./modules/accordions";
// import  "./modules/carousel";
import {CalloutCollar} from "./modules/carousel";
import {initSearchModal} from "./modules/search-modal";
require("./modules/silkNav.js");
require("./main/multidivisional.js");

new ModSlideshow();
new ModColorSlideshow();
new CLFModAccordion();
// new SimpleSlideShow();
new ModFwSlideShow();

initSearchModal();

$(function () {
  $('.row.collar').each(function (i) {
    new CalloutCollar({
      $collar: $(this)
    });
  });
});
var searchForm = $( ".local-section-search .sitesearchv3-form" );
searchForm.delegate( "*", "focus blur", function() {
  var elem = $( this );
  setTimeout(function() {
    if(elem.is( ":focus" ))
    searchForm.toggleClass( "focused" );
  }, 0 );
});

var count = 0;
$(".filter-parent").each(function () {
  var $filter = $(this);
  var count = 0;

  if (!$filter.hasClass('open')) {
    $filter.find("fieldset").css('display', 'none');
  }

  $filter.find('>label').click(function () {
    count++;
    $(this).toggleClass("open");
    $filter.find("fieldset").slideToggle("slow");
  });
});



var $details = $('details');
$details.each( function() {
	$(this).attr( 'open', '' );
});